/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
import { CustomTextField } from '../../../../../components/CustomTextField';
import { CustomSelectAndChildren } from '../../../../../components/CustomSelectAndChildren';
import { MenuItem } from '@mui/material';
import { status, STATUS_MODEL } from '../../../../../enums/statusEnum';
import { useTranslation } from 'react-i18next';
import {useState} from "react";

const VehicleFields = ({
    isUpdate,
    vehicle,
    onChange,
    emptyFields,
    currentTime,
    isValidModel,
}) => {
    const { t } = useTranslation();
    const [contractorId, setContractorId] = useState(sessionStorage.getItem('contractorId'));
    const [supplierId, setSupplierId] = useState(sessionStorage.getItem('providerId'));
    // Employee vehicles have no document approval flow, so that status is only offered to contractors and suppliers.
    const statusOptions = contractorId || supplierId
        ? [STATUS_MODEL.TO_APPROVE_DOCUMENT, STATUS_MODEL.ACTIVE, STATUS_MODEL.INACTIVE]
        : [STATUS_MODEL.ACTIVE, STATUS_MODEL.INACTIVE];

    return (
        <>
            <div className='row'>
                <div className=' col-sm-12 col-md-6'>
                    <CustomTextField
                        id='txt_vf_brand'
                        length={128}
                        name='brand'
                        value={vehicle.brand}
                        trans={'brand'}
                        type={'text'}
                        onChange={onChange}
                        required={true}
                        emptyFields={emptyFields}
                        autoComplete='off'
                    />
                </div>
                <div className=' col-sm-12 col-md-6'>
                    <CustomTextField
                        id='txt_vf_sub_brand'
                        length={128}
                        name='subBrand'
                        value={vehicle.subBrand}
                        trans={'subBrand'}
                        type={'text'}
                        onChange={onChange}
                        required={true}
                        emptyFields={emptyFields}
                        autoComplete='off'
                    />
                </div>
            </div>
            <div className='row'>
                <div className=' col-sm-12 col-md-6'>
                    <CustomTextField
                        id='txt_vf_color'
                        length={128}
                        name='color'
                        value={vehicle.color}
                        trans={'color'}
                        type={'text'}
                        onChange={onChange}
                        required={true}
                        emptyFields={emptyFields}
                        autoComplete='off'
                    />
                </div>
                <div className=' col-sm-12 col-md-6'>
                    <CustomTextField
                        id='txt_vf_model'
                        length={4}
                        name='model'
                        value={vehicle.model}
                        trans={'model'}
                        type={'number'}
                        isValid={isValidModel}
                        isValidText={t('min_1950_max_current') + ' ' + currentTime.getFullYear()}
                        onChange={onChange}
                        required={true}
                        emptyFields={emptyFields}
                        autoComplete='off'
                    />
                </div>
            </div>
            <div className='row'>
                <div className=' col-sm-12 col-md-6'>
                    <CustomTextField
                        id='txt_vf_plates'
                        length={128}
                        name='plate'
                        value={vehicle.plate}
                        trans={'plates'}
                        type={'text'}
                        onChange={onChange}
                        required={true}
                        emptyFields={emptyFields}
                        autoComplete='off'
                    />
                </div>
                <div className=' col-sm-12 col-md-6'>
                    <CustomTextField
                        id='txt_vf_vin'
                        length={128}
                        name='vin'
                        value={vehicle.vin}
                        trans={'vin'}
                        type={'text'}
                        onChange={onChange}
                        autoComplete='off'
                    />
                </div>
            </div>
            <div className='row'>
                <div className=' col-sm-12 col-md-6'>
                    <CustomTextField
                        id='txt_vf_serial_number'
                        length={128}
                        name='serialNumber'
                        value={vehicle.serialNumber}
                        trans={'serial_number'}
                        type={'text'}
                        onChange={onChange}
                        autoComplete='off'
                    />
                </div>
                {isUpdate && (
                    <div className=' col-sm-12 col-md-6'>
                        <CustomSelectAndChildren
                            id='slt_vf_status'
                            name='statusId'
                            trans='status'
                            onChange={onChange}
                            value={vehicle.statusId}
                            showNoSelectionOption={false}
                            required={true}
                            disabled={contractorId || supplierId}
                        >
                            {statusOptions.map((statusId) => {
                                return (
                                    <MenuItem key={statusId} value={statusId}>
                                        {t(status[statusId])}
                                    </MenuItem>
                                );
                            })}
                        </CustomSelectAndChildren>
                    </div>
                )}
            </div>
        </>
    );
};

export default VehicleFields;
